/**
 *
 * createComboBoxContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field, clearSubmitErrors } from 'redux-form/immutable';

import ComboBoxTextInput from './ComboBoxTextInput';
import * as actionCreators from './actions';
import * as advancedFormActionCreators from '../actions';
import {
  makeSelectIsLoaded,
  makeSelectIsCached,
  makeSelectOptions,
} from './selectors';
import {
  makeSelectRecord,
  makeSelectMode,
} from '../selectors';

function createComboBoxTextInputContainer(formName, fieldName) {
  class ComboBoxTextInputContainer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
    componentWillMount() {
      const {
        cached,
        loaded,
        loadOptions,
        mode,
      } = this.props;

      if (mode === 'view') return;
      if ((!cached || !loaded)) {
        loadOptions();
      }
    }

    handleChange = () => {
      if (this.props.clearErrorsOnChange) {
        this.props.clearErrors();
      }
      this.props.calculateFieldsValues();
    };

    render() {
      const {
        loaded,
        cached,
        loadOptions,
        clearErrorsOnChange,
        calculateFieldsValues,
        clearErrors,
        record,
        multiple,
        disabled,
        ...restProps
      } = this.props;

      return (
        <Field
          {...restProps}
          onChange={this.handleChange}
          component={ComboBoxTextInput}
          disabled={disabled}
        />
      );
    }
  }

  ComboBoxTextInputContainer.contextTypes = {
    advancedForm: PropTypes.string.isRequired,
  };

  ComboBoxTextInputContainer.propTypes = {
    cached: PropTypes.bool.isRequired,
    calculateFieldsValues: PropTypes.func.isRequired,
    clearErrors: PropTypes.func.isRequired,
    clearErrorsOnChange: PropTypes.bool,
    loaded: PropTypes.bool.isRequired,
    loadOptions: PropTypes.func.isRequired,
    mode: PropTypes.string,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    record: PropTypes.object,
  };

  const mapStateToProps = createStructuredSelector({
    loaded: makeSelectIsLoaded(formName, fieldName),
    cached: makeSelectIsCached(formName, fieldName),
    options: makeSelectOptions(formName, fieldName),
    record: makeSelectRecord(formName),
    mode: makeSelectMode(formName),
  });

  const mapDispatchToProps = (dispatch) => ({
    loadOptions: () => dispatch(actionCreators.loadOptions(formName, fieldName)),
    calculateFieldsValues: () => dispatch(advancedFormActionCreators.calculateFieldsValues(formName)),
    clearErrors: () => dispatch(clearSubmitErrors(formName)),
    addNewOption: (name) => dispatch(actionCreators.addNewOption(formName, fieldName, name)),
  });

  return connect(mapStateToProps, mapDispatchToProps)(ComboBoxTextInputContainer);
}

export default createComboBoxTextInputContainer;
